import { Observable, isObservable, of, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { ModalService } from 'ui-components/services/modal-service';

import { RateBrowserModal } from '../../components/modals/rate-browser-modal';
import * as CSWActions from '../../store/csw/csw.actions';
import * as RateViewerActions from '../../store/rate-viewer/rate-viewer.actions';
import { RateViewerTypes } from '../../enums/rate-viewer-types';
import * as Actions from './rate-browser.actions';
import { onBrowseRatesWithModel } from './rate-broswer-helpers';
import { trackWorkflow, WorkflowSteps } from '../../tracking/use-workflow-tracking';
import { Workflows } from '../../tracking/tracking-constants';

export const openRateBrowserModal = (action$) => {
  return action$.pipe(
    ofType(Actions.OPEN_RATE_BROWSER_MODAL),
    mergeMap(({ shouldBypassOpeningRateBrowserModalWithEpic }) => {
      return Observable.create((observer) => {
        if (shouldBypassOpeningRateBrowserModalWithEpic) {
          return EMPTY;
        }
        const modalId = ModalService.launchModal({
          component: RateBrowserModal,
          props: {
            onBrowseRates: (model) => {
              observer.next(onBrowseRatesWithModel(model));
            },
          },
          onClose: (isCancel) => {
            const trackCancelOrClose = isCancel ? WorkflowSteps.CANCEL : WorkflowSteps.COMPLETE;
            trackWorkflow(Workflows.RATE_BROWSER_FLOW, trackCancelOrClose);
            observer.next(
              of(
                Actions.closeRateBrowserModal(),
                RateViewerActions.clearRateViewer(RateViewerTypes.rateBrowser),
                CSWActions.resetCSW('rate-browser'),
              ),
            );
            observer.complete();
          },
        });
        observer.next(Actions.setModalId(modalId));
      }).pipe(
        mergeMap((next) => {
          return isObservable(next) ? next : of(next);
        }),
      );
    }),
  );
};
